/* eslint-disable */
import React, {Component} from 'react'
import axios from 'axios'
import {validationMobile, validationNationalId} from '../../validation/validation'
import '../../style/shop.css'
import {MDBAlert} from 'mdbreact'
import jMoment from 'moment-jalali'
import moment from 'moment-jalali'
import {objectData} from './packageFile'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'mdbreact'
import {withRouter} from 'react-router-dom'
import {MDBCollapse} from 'mdbreact'
import $ from 'jquery'
import {message} from 'antd'
import {geoLocationIds} from '../BaseComponent/geoLocationIds'
import Loader from '../loaders/loader'
import {accounting} from 'accounting'
// import {Map, Marker, TileLayer} from "react-leaflet";
import {DecryptionText} from '../Base/decryptionText'
import {packages} from './packageFile'

const token = 'e2619eb0-17a9-41d7-8ad1-919863da4d13'

class PackageShop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productInfo: {},
      current: 0,
      progressValue: 33.33,
      imageProduct: '',
      deliveryPacks: [],
      deliveryTitle: '',
      NationalId: '',
      FirstName: '',
      LastName: '',
      Password: '',
      recipientName: '',
      addressText: '',
      geoIds: [],
      selectedAddress: '',
      myAddresses: [],
      userId: '',
      userMobile: '',
      decodeMobile: '',
      latLngAddress: {
        lat: null,
        lng: null
      },
      firstUnit: 1,
      secondUnit: 1,
      mainUnitDecimal: '',
      secondUnitDecimal: '',
      finalObject: {
        DTPlanId: ''
      },
      quantityObject: {
        MinOQ: null,
        MaxComputedOQ: null,
        SecondUnitMinOQ: null,
        SecondUnitMaxOQ: null
      },
      deliveryMethodID: '',
      FeaturedImage: '',
      latLngMarker: ['', ''],
      Qty: 1,
      packages,
      packageItems: [],
      salable: true,
      localPacks: []
    }
  }

  findShare = (lists) => {
    let result = []

    for (let i = 0; i < lists.length; i++) {
      const currentList = lists[i]
      for (let j = 0; j < currentList.length; j++) {
        const currentItem = currentList[j]
        if (result.filter((x) => x.DTPlanID === currentItem.DTPlanID).length === 0) {
          let existsInAll = true
          for (let x = 0; x < lists.length; x++) {
            if (lists[x].filter((x) => x.DTPlanID === currentItem.DTPlanID).length === 0) {
              existsInAll = false
              break
            }
          }
          if (existsInAll) {
            result.push(currentItem)
          }
        }
      }
    }
    return result
  }

  renderGroupBy = (plansData) => {
    // console.log(plansData)
    // let plans = {}
    // let array = []
    // plansData.forEach(item => {
    //     plans[item.PersianDate] = item
    // })
    //
    // console.log(plans)
    //
    //
    // return plans
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.localPacks !== prevState.localPacks) {
      this.calcProductPrice()
    }
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let msisdn = urlParams.get('msisdn') === null ? '' : urlParams.get('msisdn')
    if (DecryptionText(msisdn)) {
      this.setState({
        userMobile: DecryptionText(msisdn),
        decodeMobile: DecryptionText(msisdn)
      })
    } else {
      this.setState({
        decodeMobile: ''
      })
    }

    $(function() {
      $('.header').hide()
    })

    let {id} = this.props.match.params

    let findIndex = this.state.packages.findIndex((item) => Number(item.packId) === Number(id))

    if (findIndex >= 0) {
      let pack = this.state.packages[findIndex].items
      this.setState({
        localPacks: pack
      })
      for (let i in pack) {
        axios
          .get(`https://beroozmart.com/api/products/getbyid?id=${pack[i].ArticleID}`, {
            crossdomain: true
          })
          .then((res) => {
            let packageItems = this.state.packageItems
            packageItems.push({
              PBD: res.data.PBD,
              PAD: res.data.PAD,
              ArticleID: res.data.ArticleID,
              MaxComputedOQ: res.data.MaxComputedOQ,
              SPID: res.data.StockProductID,
              FeaturedImage: res.data.FeaturedImage,
              plans: res.data.DeliveryDetails.DeliverableTimes[0].Plans,
              PUID: res.data.ProductUnit.ProductUnitID,
              Title: res.data.Title,
              DeliveryMethodID: res.data.DeliveryDetails.DeliverableTimes[0].DeliveryMethod.DeliveryMethodID
            })

            for (let i in packageItems) {
              let find = pack.find((item) => item.ArticleID === packageItems[i].ArticleID)
              if (find) {
                find.FeaturedImage = packageItems[i].FeaturedImage
                find.SPID = packageItems[i].SPID
                find.PUID = packageItems[i].PUID
                find.PBD = packageItems[i].PBD
                find.PAD = packageItems[i].PAD
                find.productName = packageItems[i].Title
              }
            }

            let initialVal = 0
            let sumAfterPrice = pack.reduce(function(acc, current) {
              return Number(acc) + Number(Number(current.PAD) * Number(current.QTY))
            }, initialVal)

            let sumBeforePrice = pack.reduce(function(acc, current) {
              return Number(acc) + Number(Number(current.PBD) * Number(current.QTY))
            }, initialVal)

            let discount = Number(sumBeforePrice) - Number(sumAfterPrice)

            this.setState({
              allItemsPrice: sumAfterPrice,
              packPrice: sumAfterPrice,
              discountPack: discount,
              priceBeforeDiscount: sumBeforePrice,
              precentDiscount: (
                100 -
                (Number(100) * Number(sumAfterPrice)) / (Number(sumAfterPrice) + Number(discount))
              ).toFixed(0)
            })

            let planArr = []
            let deliveryMethodArr = []
            packageItems.forEach((item) => {
              planArr.push(item.plans)
              deliveryMethodArr.push([{id: item.DeliveryMethodID}])
            })

            this.setState({
              deliveryPacks: this.findShare(planArr),
              shareDeliveryMethodId: this.findShare(deliveryMethodArr),
              localPacks: pack,
              titlePackage: this.state.packages[findIndex].title,
              packageItems
            })

            let find = packageItems.find((item) => Number(item.MaxComputedOQ) < Number(pack[i].QTY))
            if (find) {
              this.setState({
                salable: false
              })
            }
            if (this.findShare(planArr).length === 0) {
              this.setState({
                salable: false
              })
            }
          })
      }
    } else {
      this.setState({
        noPackage: true
      })
    }
  }

  calcProductPrice = () => {
    let localPacks = this.state.localPacks

    let initialVal = 0
    let sumAfterPrice = localPacks.reduce(function(acc, current) {
      return Number(acc) + Number(Number(current.PAD) * Number(current.QTY))
    }, initialVal)

    //
    // let sumBeforeDicount = localPacks.reduce(function (acc, current) {
    //     return Number(acc) + Number(current.PBD * current.QTY)
    // }, initialVal);
    //
    // let discount = Number(sumBeforeDicount) - Number(sumAfterPrice)
    //
    // console.log(sumAfterPrice)
    // console.log(sumBeforeDicount)

    // var initialVal = 0
    //
    // var sumPrice = localPacks.reduce(function (acc, current) {
    //     return Number(acc) + Number(current.price * current.QTY)
    // }, initialVal);
    //
    // let {id}=this.props.match.params;
    //
    // let findIndex = this.state.packages.findIndex(item => Number(item.packId) === Number(id))
    // if(findIndex >= 0){
    //     let packPrice = this.state.packages[findIndex].priceAfterDiscount
    //     let discountPack = this.state.packages[findIndex].discount
    //
    //     this.setState({
    //         allItemsPrice: sumPrice,
    //         packPrice,
    //         discountPack,
    //         priceBeforeDiscount: Number(packPrice) + Number(discountPack),
    //         precentDiscount: (100 - (Number(100) * Number(packPrice)) / (Number(packPrice) + Number(discountPack))).toFixed(0)
    //     })
    // }
  }

  nextStep = () => {
    let current = this.state.current
    if (current === 1) {
      let userMobile = document.getElementById('userMobile').value.trim()
      if (userMobile === '') {
        message.error('شماره موبایل خود را وارد کنید')
      } else {
        this.checkExistUser(this.state.userMobile)
      }
    } else if (current === 2) {
      this.setState({
        loadingShop: true
      })
      let myAddresses = this.state.myAddresses.find((item) => item.checked === true)
      if (myAddresses) {
        let {shareDeliveryMethodId, packPrice, allItemsPrice, localPacks} = this.state
        let packItems = []
        let items = []

        for (let i in localPacks) {
          packItems.push({
            SPID: localPacks[i].SPID,
            PUID: localPacks[i].PUID,
            DTPlanID: this.state.finalObject.DTPlanId
          })
          items.push({
            SPID: localPacks[i].SPID,
            PUID: localPacks[i].PUID,
            Qty: localPacks[i].QTY
          })
        }
        // alert(packPrice)
        // alert(allItemsPrice)

        if (packPrice > allItemsPrice) {
          if (packPrice < 500000) {
            let data = {
              UserId: this.state.userId,
              recipientID: myAddresses.RecipientID,
              deliveryMethodID: shareDeliveryMethodId[0].id,
              paymentMethodId: 4,
              allowPayViaCredit: false,
              paperInvoice: false,
              packItems: packItems,
              basketModel: {
                items: items
              },
              DeliveryFee: Number(packPrice - allItemsPrice) + 50000
            }
            // alert(JSON.stringify(data))
            this.createInvoiceByAdmin(data)
          } else {
            let data = {
              UserId: this.state.userId,
              recipientID: myAddresses.RecipientID,
              deliveryMethodID: shareDeliveryMethodId[0].id,
              paymentMethodId: 4,
              allowPayViaCredit: false,
              paperInvoice: false,
              packItems: packItems,
              basketModel: {
                items: items
              },
              DeliveryFee: Number(packPrice - allItemsPrice)
            }
            // alert(Number(packPrice - allItemsPrice))
            // alert(JSON.stringify(data))

            this.createInvoiceByAdmin(data)
          }
        } else if (packPrice < allItemsPrice) {
          let data = {
            UserId: this.state.userId,
            recipientID: myAddresses.RecipientID,
            deliveryMethodID: shareDeliveryMethodId[0].id,
            paymentMethodId: 4,
            allowPayViaCredit: false,
            paperInvoice: false,
            packItems: packItems,
            basketModel: {
              items: items
            },
            MemberDiscount: Math.abs(Number(packPrice - allItemsPrice))
          }
          // alert(JSON.stringify(data))

          this.createInvoiceByAdmin(data)
        } else if (packPrice === allItemsPrice) {
          let data = {
            UserId: this.state.userId,
            recipientID: myAddresses.RecipientID,
            deliveryMethodID: shareDeliveryMethodId[0].id,
            paymentMethodId: 4,
            allowPayViaCredit: false,
            paperInvoice: false,
            packItems: packItems,
            basketModel: {
              items: items
            }
          }
          // alert(JSON.stringify(data))
          // alert(packPrice)
          // alert(allItemsPrice)
          // alert(JSON.stringify(data))
          this.createInvoiceByAdmin(data)
        }
      } else {
        message.error('یک آدرس را انتخاب کنید')
      }
    }
  }

  createInvoiceByAdmin = (data) => {
    axios({
      method: 'post',
      url: 'https://beroozmart.com/api/basket/CreateInvoiceByAdmin?token=' + token,
      data: data
    })
      .then((res) => {
        let Iid = res.data.Iid

        message.success('ثبت سفارش با موفقیت انجام شد.لطفا صبر کنید')
        this.setState({
          loadingShop: false
        })
        setTimeout(() => {
          window.location.assign('https://beroozmart.com/pay?iid=' + Iid + '&pmid=11')
        }, 2000)
      })
      .catch((err) => {
        this.setState({
          loadingShop: false
        })
        message.error(JSON.stringify(err))
      })
  }

  selectDeliveryPack = (num, checked) => {
    let deliveryPacks = this.state.deliveryPacks
    for (let i in deliveryPacks) {
      deliveryPacks[i].checked = false
    }
    deliveryPacks[num].checked = !checked
    this.setState({
      deliveryPacks
    })
  }

  clickOnMap = (e) => {
    let lat = e.latlng.lat
    let lng = e.latlng.lng

    let latLngAddress = {
      lat,
      lng
    }
    axios
      .get(`https://api.neshan.org/v1/reverse?lat=${lat}&lng=${lng}`, {
        headers: {
          'Api-Key': 'service.tDyHKnFkOkYeabYPKdnrZvuA4Aq4c1jFESmpf2K4'
        }
      })
      .then((respond) => {
        let addresstext = respond.data.city + ' - ' + respond.data.neighbourhood + ' - ' + respond.data.address

        this.setState({
          latLngAddress,
          addressText: addresstext,
          latLngMarker: [lat, lng]
        })
      })
  }

  addAddress = () => {
    let address = this.state.addressText
    let FullName = this.state.recipientName
    let Coordinates = this.state.latLngAddress
    let GeoLocationId = document.getElementById('GeoLocationId').value
    let Mobile = document.getElementById('Mobile').value
    if (address === '' || FullName === '' || GeoLocationId === '' || Mobile === '') {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (!validationMobile(Mobile)) {
      message.error('شماره موبایل وارد شده معتبر نیست')
    } else {
      let data = {
        UserId: this.state.userId,
        Address: address,
        Coordinates: `${Coordinates.lat},${Coordinates.lng}`,
        FullName: FullName,
        GeoLocationID: Number(GeoLocationId),
        Mobile: Mobile
      }
      console.log(data)

      axios({
        method: 'post',
        url: 'https://beroozmart.com/api/recipients/admincreate?token=e2619eb0-17a9-41d7-8ad1-919863da4d13',
        data: data
      })
        .then((res) => {
          message.success('آدرس  جدید با موفقیت ثبت شد')
          let userId = this.state.userId
          this.setState({
            modalAddAddres: false
          })
          this.getAllAddress(userId)
        })
        .catch((err) => {})

      // this.setState({
      //     modalAddresses:false
      // })
    }
  }

  changeCity = (e) => {
    let value = e.target.value
    if (value !== '') {
      let findGeo = geoLocationIds.filter((item) => Number(item.ParentID) === Number(value))
      this.setState({
        geoIds: findGeo
      })
    } else {
      this.setState({
        geoIds: []
      })
    }
    // alert(value)
  }

  changeInputs = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }

  registerUser = () => {
    let {FirstName, LastName, userMobile, NationalId, Password} = this.state

    if (FirstName === '' || LastName === '' || userMobile === '' || NationalId === '' || Password === '') {
      message.error('همه فیلد هارا تکمیل کنید')
    } else if (!validationNationalId(NationalId)) {
      message.error('کد ملی وارد شده معتبر نیست')
    } else {
      this.setState({
        loading: true
      })
      let data = {
        Mobile: userMobile,
        FirstName,
        LastName,
        NationalID: NationalId,
        Password
      }

      axios({
        url: 'https://beroozmart.com/api/users/admincreate?token=' + token,
        method: 'post',
        data: data
      })
        .then((res) => {
          this.setState({
            userId: res.data.id,
            progressValue: 100,
            current: this.state.decodeMobile === '' ? this.state.current + 1 : 2,
            modalAddAddres: true,
            loading: false,
            modalRegister: false
          })
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
          if (err.response.request.responseText) {
            let errCode = err.response.request.responseText
            if (errCode.includes('40125')) {
              message.error('کد ملی قبلا ثبت شده است')
            }
          } else {
            message.error(JSON.stringify(err))
          }
          // console.log(1,err.response.request)
          // console.log(2,err.response.request.responseText)
          // console.log(3,err.response.responseText)
          // message.error(JSON.stringify(err))
        })
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  checkExistUserByKey = (userMobile) => {
    this.setState({
      loadingShop: true
    })
    axios
      .get(
        `https://beroozmart.com/api/users/exists?mobile=${userMobile}&token=e2619eb0-17a9-41d7-8ad1-919863da4d13`,
        {}
      )
      .then((respond) => {
        this.setState({
          loadingShop: false
        })

        let userId = respond.data.Id
        this.setState({
          userId: respond.data.Id,
          progressValue: 100,
          current: 2
        })
        this.getAllAddress(userId)
      })
      .catch((err) => {
        this.setState({
          modalRegister: true,
          loadingShop: false
        })
      })
  }

  checkExistUser = (userMobile) => {
    // let {userMobile} = this.state;
    if (this.convertDigit(userMobile) == '') {
      message.error('شماره موبایل را وارد کنید')
    } else if (!validationMobile(this.convertDigit(userMobile))) {
      message.error('شماره همراه صحیح را وارد کنید')
    } else {
      axios
        .get(
          `https://beroozmart.com/api/users/exists?mobile=${userMobile}&token=e2619eb0-17a9-41d7-8ad1-919863da4d13`,
          {}
        )
        .then((respond) => {
          let userId = respond.data.Id
          this.setState({
            userId: respond.data.Id,
            progressValue: 100,
            current: this.state.current + 1
          })
          this.getAllAddress(userId)
        })
        .catch((err) => {
          this.setState({
            modalRegister: true
          })
        })
    }
  }

  getAllAddress = (userId) => {
    axios({
      method: 'get',
      url: `https://beroozmart.com/api/recipients/admingetall?id=${userId}&token=e2619eb0-17a9-41d7-8ad1-919863da4d13`
    })
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({
            myAddresses: res.data,
            modalAddAddres: false
          })
        } else {
          this.setState({
            modalAddAddres: true,
            myAddresses: res.data
          })
        }
        // alert(JSON.stringify(res))
      })
      .catch((err) => {})
  }

  changeFirstUnit = (e, isDecimal) => {
    let value = e.target.value

    if (!isDecimal) {
      if (!value.match(/^[1-9]\d*$/g)) {
        console.log('no')
        this.setState({
          firstUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          firstUnit: Number(value),
          Qty: Number(value)
        })
      }
    } else {
      if (!value.match(/^[1-9]\d*(\.\d+)?$/g)) {
        console.log('no')
        this.setState({
          firstUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          firstUnit: Number(value),
          Qty: Number(value)
        })
      }
    }
  }

  changeSecondUnit = (e, isDecimal) => {
    let value = e.target.value

    if (!isDecimal) {
      if (!value.match(/^[1-9]\d*$/g)) {
        console.log('no')
        this.setState({
          secondUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          secondUnit: Number(value),
          Qty: Number(value)
        })
      }
    } else {
      if (!value.match(/^[1-9]\d*(\.\d+)?$/g)) {
        console.log('no')
        this.setState({
          secondUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          secondUnit: Number(value),
          Qty: Number(value)
        })
      }
    }
  }

  goLoginPage = (productValue, PUId) => {
    let find = this.state.deliveryPacks.find((item) => item.checked === true)
    // let MinOQ = this.state.quantityObject.MinOQ
    // let MaxComputedOQ = this.state.quantityObject.MaxComputedOQ
    // let SecondUnitMinOQ = this.state.quantityObject.SecondUnitMinOQ
    // let SecondUnitMaxOQ = this.state.quantityObject.SecondUnitMaxOQ
    if (!find) {
      message.error('بازه تحویل از جدول زیر انتخاب شود ')
    }
    // else if(MinOQ !== null && productValue < MinOQ){
    //     message.error(`حداقل باید ${MinOQ} تعداد سفارش داده شود`)
    // }
    // else if(MaxComputedOQ !== null && productValue > MaxComputedOQ){
    //     message.error(`حداکثر باید ${MaxComputedOQ} تعداد سفارش داده شود`)
    // }
    // else if(SecondUnitMinOQ !== null && productValue < SecondUnitMinOQ){
    //     message.error(`حداقل باید ${SecondUnitMinOQ} تعداد سفارش داده شود`)
    // }
    // else if(SecondUnitMaxOQ !== null && productValue > SecondUnitMaxOQ){
    //     message.error(`حداکثر باید ${<SecondUnitMaxOQ></SecondUnitMaxOQ>} تعداد سفارش داده شود`)
    // }
    else {
      if (this.state.decodeMobile === '') {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        // finalObject.PUId = PUId
        // finalObject.SPId = this.state.StockProductID
        // finalObject.productValue = productValue
        this.setState({
          finalObject,
          current: 1,
          progressValue: 66.66
        })
      } else {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID

        // finalObject.PUId = PUId
        // finalObject.SPId = this.state.StockProductID
        // finalObject.productValue = productValue
        this.setState({
          finalObject
        })
        this.checkExistUserByKey(this.state.decodeMobile)
      }
    }
  }

  goLoginPageBySecoundUnit = (productValue, PUId) => {
    let find = this.state.deliveryPacks.find((item) => item.checked === true)
    // let MinOQ = this.state.quantityObject.MinOQ
    // let MaxComputedOQ = this.state.quantityObject.MaxComputedOQ
    let SecondUnitMinOQ = this.state.quantityObject.SecondUnitMinOQ
    let SecondUnitMaxOQ = this.state.quantityObject.SecondUnitMaxOQ
    if (!find) {
      message.error('بازه تحویل از جدول زیر انتخاب شود ')
    } else if (SecondUnitMinOQ !== null && productValue < SecondUnitMinOQ) {
      message.error(`حداقل باید ${SecondUnitMinOQ} تعداد سفارش داده شود`)
    } else if (SecondUnitMaxOQ !== null && productValue > SecondUnitMaxOQ) {
      message.error(`حداکثر باید ${SecondUnitMaxOQ} تعداد سفارش داده شود`)
    }

    // else if(MinOQ !== null && productValue < MinOQ){
    //     message.error(`حداقل باید ${MinOQ} تعداد سفارش داده شود`)
    // }
    // else if(MaxComputedOQ !== null && productValue > MaxComputedOQ){
    //     message.error(`حداکثر باید ${MaxComputedOQ} تعداد سفارش داده شود`)
    // }
    else {
      if (this.state.decodeMobile === '') {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        finalObject.PUId = PUId
        finalObject.SPId = this.state.StockProductID
        finalObject.productValue = productValue
        this.setState({
          finalObject,
          current: 1,
          progressValue: 66.66
        })
      } else {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        finalObject.PUId = PUId
        finalObject.SPId = this.state.StockProductID
        finalObject.productValue = productValue
        this.setState({
          finalObject
        })
        this.checkExistUserByKey(this.state.decodeMobile)
      }
    }
  }

  setAddress = (num, checked) => {
    let myAddresses = this.state.myAddresses
    for (let i in myAddresses) {
      myAddresses[i].checked = false
    }
    myAddresses[num].checked = !checked
    this.setState({
      myAddresses
    })
  }

  render() {
    let {productInfo} = this.state
    let position = [this.state.latLngAddress.lat, this.state.latLngAddress.lng]
    let {id} = this.props.match.params

    let findIndex = this.state.packages.findIndex((item) => Number(item.packId) === Number(id))
    const renderImage =
      findIndex >= 0 ? (
        <img src={require('../../packagesImage/' + id + '.jpg')} width={'65%'} className="d-block m-auto" />
      ) : null

    let stepData = [
      {
        title: 'انتخاب پکیج',
        content: (
          <div className="container">
            <div className="row">
              <div className="col-12 p-0 position-relative">{renderImage}</div>
            </div>
            <div className="row justify-content-between align-content-center align-items-center">
              <section className="select-product my-1 my-md-0">
                {this.state.discountPack !== 0 && (
                  <>
                    <span style={{fontSize: '1.2em'}} className="text-muted pbd-price position-relative mx-2">
                      <span className="khat position-absolute" />
                      {'قیمت قبلی : ' +
                        accounting.formatMoney(this.state.priceBeforeDiscount / 10, '', ',') +
                        ' تومان '}
                    </span>
                    <span className="discount">
                      <span className="discountText d-inline-block p-2">تخفیف</span>
                      <span className="discountVal d-inline-block p-2">{this.state.precentDiscount + ' % '}</span>
                    </span>
                  </>
                )}
                <span className="d-block font-weight-bold mx-2 my-2" style={{fontSize: '1.4em'}}>
                  {'قیمت : ' + ' ' + accounting.formatMoney(this.state.packPrice / 10, '', ',') + ' تومان '}
                </span>
              </section>
              <button onClick={() => this.goLoginPage()} className="add-product-btn small py-2 my-1 my-md-0">
                {!this.state.salable || this.state.deliveryPacks.length === 0
                  ? 'غیر قابل فروش'
                  : 'ثبت کالا و مرحله بعد'}
              </button>
            </div>
            <div className="row">
              <div className="col-12 p-0 mt-2">
                <div className="card">
                  <div
                    className="card-header d-flex flex-row justify-content-between align-items-center align-content-center"
                    onClick={() => this.setState({showPackageItems: !this.state.showPackageItems})}
                  >
                    <span className="font-weight-bold">{this.state.titlePackage}</span>
                    <button className="bg-transparent border-0">
                      <span className="small">نمایش اقلام</span>
                      {this.state.showPackageItems ? (
                        <img className="mx-2" src={require('../../image/caretUp.svg')} width="15px" />
                      ) : (
                        <img className="mx-2" src={require('../../image/caretDown.svg')} width="15px" />
                      )}
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <MDBCollapse id="basicCollapse" isOpen={this.state.showPackageItems}>
                      <div className="p-2">
                        {this.state.localPacks.map((item) => (
                          <div className="d-flex flex-row p-2 justify-content-between">
                            <div className="w-75 d-flex flex-row align-items-center align-content-center">
                              <img
                                className="img-thumbnail"
                                width={60}
                                src={'https://beroozmart.com/' + item.FeaturedImage}
                              />
                              <span className="mx-2">{item.productName}</span>
                            </div>
                            <div className="w-25 text-right d-flex flex-row align-items-center align-content-center justify-content-end">
                              <span className="">
                                {'تعداد :‌ '} {item.QTY}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </MDBCollapse>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-0 my-2">
                {this.state.deliveryPacks.length !== 0 && (
                  <section>
                    <div className="card">
                      <div className="card-header text-center">
                        <span className="text-center font-weight-bold">انتخاب بازه تحویل</span>
                      </div>
                      <div className="card-body">
                        <table className="table table-sm table-striped w-100">
                          <tbody>
                            {this.state.deliveryPacks.map((del, index) => (
                              <tr onClick={() => this.selectDeliveryPack(index, del.checked)}>
                                <td className="text-center">
                                  <span className="d-block font-weight-bold small text-dark"> {del.WeekDay}</span>
                                  <span className="d-block font-weight-bold small text-muted">{del.PersianDate}</span>
                                </td>
                                <td className="text-center">
                                  <span className="d-inline-block font-weight-bold p-2 text-muted">
                                    ساعت {del.From.substr(0, 2)} تا {del.To.substr(0, 2)}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <img
                                    className="mt-2"
                                    src={
                                      del.checked
                                        ? require('../../image/checkradio.svg')
                                        : require('../../image/uncheckradio.svg')
                                    }
                                    width="20px"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                )}
              </div>
            </div>
          </div>
        )
      },

      {
        title: 'مشخصات کاربر',
        content: (
          <div className="container p-0">
            <div className="row">
              <div className="col-12">
                <div className="m-auto">
                  <label>شماره موبایل</label>
                  <input
                    type="text"
                    name="userMobile"
                    placeholder="09xxxxxxxxx"
                    id="userMobile"
                    defaultValue={this.state.userMobile}
                    onChange={this.changeInputs}
                    className="form-control w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      },
      {
        title: 'انتخاب آدرس و پرداخت',
        content: (
          <div className="container p-0">
            <div className="card">
              <div className="card-header p-1">
                {this.state.modalAddAddres ? (
                  <span className="small font-weight-bold">ثبت آدرس جدید</span>
                ) : (
                  <button
                    className="btn btn-sm btn-info m-0"
                    onClick={() =>
                      this.setState({
                        modalListAddress: false,
                        modalAddAddres: true
                      })
                    }
                  >
                    ثبت آدرس جدید
                  </button>
                )}
              </div>
              <MDBCollapse id="basicCollapse" isOpen={!this.state.modalAddAddres}>
                <div className="card-body p-1">
                  <table className="table table-bordered deliveryPackTable">
                    <thead>
                      <tr>
                        {/*<th className='text-center text-dark font-weight-bold'>ردیف</th>*/}
                        <th className="text-center text-dark font-weight-bold">آدرس</th>
                        <th className="text-center text-dark font-weight-bold">تحویل گیرنده</th>
                        <th className="text-center text-dark font-weight-bold">انتخاب</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.myAddresses.map((item, index) => (
                        <tr>
                          {/*<td className='text-center'>*/}
                          {/*<span className='d-block font-weight-bold small text-dark'>*/}
                          {/*    {index + 1}*/}
                          {/*</span>*/}
                          {/*</td>*/}
                          <td className="text-center">
                            <span className="d-inline-block font-weight-bold text-muted">{item.Address}</span>
                          </td>
                          <td>
                            <span className="d-inline-block font-weight-bold text-muted">{item.FullName}</span>
                          </td>
                          <td className="text-center" onClick={() => this.setAddress(index, item.checked)}>
                            <img
                              className="mt-2"
                              src={
                                item.checked
                                  ? require('../../image/checkradio.svg')
                                  : require('../../image/uncheckradio.svg')
                              }
                              width="20px"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
              <MDBCollapse id="basicCollapse" isOpen={this.state.modalAddAddres}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12 addressMap mb-2">
                      {/* <Map center={[35.6892,51.3890]} zoom={12}
                                             onClick={this.clickOnMap}
                                        >
                                            <TileLayer

                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            <Marker position={this.state.latLngMarker}>

                                            </Marker>
                                        </Map> */}

                      {/*<Map*/}
                      {/*    google={this.props.google}*/}
                      {/*    zoom={11}*/}
                      {/*    initialCenter={{*/}
                      {/*        lat: 35.6892,*/}
                      {/*        lng: 51.3890*/}
                      {/*    }}*/}
                      {/*    onClick={this.clickOnMap}*/}
                      {/*>*/}
                      {/*    <Marker*/}
                      {/*        position={{lat: this.state.latLngAddress.lat, lng: this.state.latLngAddress.lng}}>*/}
                      {/*    </Marker>*/}
                      {/*</Map>*/}
                    </div>
                    <div className="col-sm-12">
                      <label>
                        آدرس :<span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <textarea
                        id="locAddress"
                        name="addressText"
                        value={this.state.addressText}
                        onChange={this.changeInputs}
                        className="form-control w-100"
                        style={{minHeight: '150px'}}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label>
                        شهر :<span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <select className="form-control" onChange={this.changeCity}>
                        <option value="">------</option>
                        {geoLocationIds
                          .filter(
                            (item) =>
                              item.GeoLocationID === 4131 ||
                              item.GeoLocationID === 4135 ||
                              item.GeoLocationID === 4540 ||
                              item.GeoLocationID === 4127
                          )
                          .map((geo, index) => (
                            <option value={geo.GeoLocationID}>{geo.Title}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <label>
                        منطقه :<span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <select className="form-control" id="GeoLocationId">
                        <option value="">------</option>
                        {this.state.geoIds.map((item, index) => (
                          <option value={item.GeoLocationID}>{item.Title}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <label>
                        تحویل گیرنده
                        <span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <input type="text" onChange={this.changeInputs} name="recipientName" className="form-control" />
                    </div>
                    <div className="col-sm-6">
                      <label>
                        شماره موبایل
                        <span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <input
                        type="text"
                        onChange={this.changeInputs}
                        name="Mobile"
                        id="Mobile"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer p-4">
                  <div className="row">
                    <div className="col-12">
                      <button className="confirmBtnModal" onClick={this.addAddress}>
                        ثبت آدرس
                      </button>
                      <button className="cancelBtnModal mx-3" onClick={() => this.setState({modalAddAddres: false})}>
                        لغو
                      </button>
                    </div>
                  </div>
                </div>
              </MDBCollapse>
            </div>
          </div>
        )
      }
    ]

    return (
      <div className="position-relative" style={{marginTop: '-80px'}}>
        <div
          style={{width: '100%', minHeight: 50, background: '#f705bc'}}
          className="d-flex d-md-none flex-row align-content-center align-items-center justify-content-center"
        >
          {/*<img src={require('../../image/vitrin.png')} width='30%' height={'auto'}/>*/}
        </div>
        {this.state.noPackage ? (
          <div className="alert-danger w-75 m-auto p-3">
            <strong>پکیج مورد نظر وجود ندارد</strong>
          </div>
        ) : (
          <div className="p-3 p-md-0">
            <div className="container p-0">
              <div className="row">
                <div className="col-12 pb-0">
                  <ul className="p-0 w-100 step-shop d-flex flex-row">
                    {stepData.map((item, index) => (
                      <li className="d-inline-block">
                        <div
                          className={
                            index <= this.state.current
                              ? 'circle-step active-circle-step m-auto text-center d-flex flex-row justify-content-center align-items-center'
                              : 'circle-step m-auto text-center d-flex flex-row justify-content-center align-items-center'
                          }
                        >
                          <span>{index + 1}</span>
                        </div>
                        <p className="mt-1 mb-0 font-weight-bold">{item.title}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="p-3 body-step container bg-white position-relative">
              {this.state.loadingShop && (
                <div className="loading-shop d-flex flex-row justify-content-center align-items-center align-content-center">
                  <p className="font-weight-bold">لطفا صبر کنید</p>
                </div>
              )}

              {stepData[this.state.current].content}
            </div>
            {this.state.current !== 0 && !this.state.modalAddAddres && (
              <div className={'footer-step mt-2 container'}>
                <div className="container py-3">
                  <div className="row">
                    <div className="col-12 p-0 d-flex flex-row justify-content-between">
                      <button
                        disabled={this.state.loadingShop}
                        onClick={this.nextStep}
                        className="confirmBtnModal font-weight-bold"
                      >
                        {this.state.current === stepData.length - 1 ? 'پرداخت' : 'مرحله بعد'}
                      </button>
                      {this.state.current !== 0 && (
                        <button
                          className="cancelBtnModal font-weight-bold"
                          onClick={() =>
                            this.setState({
                              current: this.state.current - 1,
                              progressValue: this.state.progressValue - 33.33
                            })
                          }
                        >
                          مرحله قبل
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <Modal isOpen={this.state.modalRegister} toggle={() => this.setState({modalRegister: false})} size="lg">
          <ModalHeader toggle={() => this.setState({modalRegister: false})}>ثبت نام</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <div className="w-100">
              <p className="text-danger text-center font-weight-bold">
                شماره موبایل شما در سیستم وجود ندارد.لطفا فرم زیر را برای ثبت نام تکمیل کنید
              </p>
            </div>
            <hr className="mb-0" />
            <div className="container-fluid">
              <div className="row justify-content-between">
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">نام</label>
                  <input type="text" name="FirstName" className="form-control w-100" onChange={this.changeInputs} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">نام خانوادگی</label>
                  <input type="text" name="LastName" className="form-control w-100" onChange={this.changeInputs} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">کد ملی</label>
                  <input type="text" name="NationalId" className="form-control w-100" onChange={this.changeInputs} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">کلمه عبور</label>
                  <input type="password" name="Password" className="form-control w-100" onChange={this.changeInputs} />
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.registerUser}>
              ثبت نام
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalRegister: false, modalLogin: true})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default PackageShop
//
// export default withRouter(GoogleApiWrapper({
//     apiKey: ('AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw')
// })(PhoneShop))
